import { useEffect, useState } from 'react';

const systemDarkTheme = window.matchMedia('(prefers-color-scheme: dark)');

export const useSystemDarkTheme = () => {
  const [isDarkTheme, setIsDarkTheme] = useState(systemDarkTheme.matches);

  useEffect(() => {
    const handleChange = (event: MediaQueryListEvent): void => {
      setIsDarkTheme(event.matches);
    };

    systemDarkTheme.addEventListener('change', handleChange);

    return () => systemDarkTheme.removeEventListener('change', handleChange);
  }, []);

  return isDarkTheme;
};
